export default "__VITE_ASSET__DTcDZWNh__"